import React from "react";
import themes from "./util";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import Content from "./components/Content";
import { QueryClient, QueryClientProvider } from "react-query";
import CssBaseline from "@mui/material/CssBaseline";
import { MapContextProvider } from "./contexts";
import "./util/theme/fonts/fonts.css";
import AOS from "aos";
import "aos/dist/aos.css";

const queryClient = new QueryClient();
const theme = themes.default;
theme.brand = "default";

function App() {
  AOS.init();

  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <MapContextProvider>
            <Content />
          </MapContextProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
}

export default App;
